import React from "react";
import { FormGroup, Form, Container } from "react-bootstrap";
import { Breadcrumb, MainHeader, MainFooter } from "../../components";
import { Input } from 'antd';
import { Link } from "react-router-dom";

function AffiliateForgotpassword() {
    const breadcrumb = [
        {
            path: '/Home',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Forgot Password',
        },
    ];
    return (
        <>
            <MainHeader />
            <main className="becomePage becomePage_affiliate">
                <Container>
                    <Breadcrumb title="Forgot Password" breadcrumb={breadcrumb} />
                    <div className="becomePage_inner">
                        <div className="becomePage_head mb-0">
                            <div className="becomePage_signup text-center">
                                <h2 className="mb-1 font-sm">Forgot Password</h2>
                                <p>Submit Email or Mobile Number to reset your password.</p>
                            </div>                            
                        </div>
                        <div className="becomePage_auth mx-auto mb-0">
                            <Form>
                                <FormGroup className="form-group">
                                    <label className="ant-label">Mobile Number/Email</label>
                                    <Input type="email" size="large" placeholder="Mobile Number/Email" value="aditi@mailinator.com" />
                                </FormGroup>
                                <div className="text-end becomePage_affiliate_txt">
                                    <Link to="/affiliate-login" className="forgotxt d-inline-block">Login</Link>
                                </div>
                                <div className="text-center becomePage_affiliate_btn">
                                    <Link to="/affiliate-reset-password" className="ms-auto w-100 btn btn-primary btn-lg">Recover Password</Link>
                                </div>
                                {/* <div className="text-center becomePage_affiliate_txt">
                                    Don’t have account? <Link to="/become-a-super-fan" className="forgotxt font-md mb-0 ">Sign Up</Link>
                                </div> */}
                            </Form>
                        </div>
                    </div>
                </Container>
            </main>
            <MainFooter />
        </>
    );
}

export default AffiliateForgotpassword;